export const notificationPlugin = {
  install(app) {
    app.config.globalProperties.$notify = (message, type = 'info', duration = 3000) => {
      // Логика показа уведомления
    }
  }
} 